<template>
  <section class="main-season" :class="{'is-ios': isIOS}">
    <div
      v-if="category.length > 0"
      class="main-content"
    >
      <router-link
        :to="{
          name: 'Writing',
          params: {
            locale: $route.params.locale,
            category: category[0].categorySeq
          },
          query: {page:1, offset: true}
        }"
      >
        <div class="season-image season-1">
          <!--        <img src="@/static/image/main/pc/season_1_bg.jpg" alt="">-->
        </div>
        <div class="season-desc">
          <!--        <p><img src="@/static/image/main/season_1_logo_green.png" :alt="$t('main.season.season-1.logo')"></p>-->
          <p>
            <logo-baemin-green />
          </p>
          <p>
            <html-view tag="strong" :value="$t('main.season.season-1.title')" />
          </p>
          <div class="season-character">
            <img
              src="~@/static/image/main/season_1_character_docgo.png"
              srcset="~@/static/image/main/season_1_character_docgo@2x.png 2x, ~@/static/image/main/season_1_character_docgo@3x.png 3x"
              alt=""
            >
          </div>
          <html-view tag="p" :value="$t('main.season.season-1.desc')" />
        </div>

        <!--        <div class="season-image"><img src="@/static/image/temp/main/season_2_bg.jpeg" alt=""></div>-->
        <!--        <div class="season-desc">-->
        <!--          <p>우아한형제들도 함께하고 있어요</p>-->
        <!--          <p><strong>가족과 함께<br> 좋은 음식을 먹고 싶은 곳에서</strong></p>-->
        <!--          <p>배달의민족은 언제나 의미있는 문제 해결을 위해 지속적인 관심과 약속을 할 것입니다.<br> 오늘은 ‘환경의날’.  배달의민족이 일회용품 안받기를 기본으로 설정한 것<br> 또한 하나의 약속을 위한 이유입니다.</p>-->
        <!--          <p><a href="" class="btn btn-fade">앱 다운로드</a></p>-->
        <!--        </div>-->

        <!--        <div class="season-image">-->
        <!--          <img src="@/static/image/temp/main/season_3_bg.jpeg" alt="">-->
        <!--        </div>-->
        <!--        <div class="season-desc">-->
        <!--          <p>우아한형제들도 함께하고 있어요</p>-->
        <!--          <p><strong>오늘은 2020년 6월 5일<br> ‘환경의 날’입니다.</strong></p>-->
        <!--          <p>배달의민족은 언제나 의미있는 문제 해결을 위해<br> 지속적인 관심과 약속을 할 것입니다. 오늘은 ‘환경의날'.<br> 배달의민족이 일회용품 안받기를 기본으로 설정한것 또한<br> 하나의 약속을 위한 이유입니다.</p>-->
        <!--        </div>-->
        <!--        <observer :type="['pc','m']" />-->
      </router-link>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    logoBaeminGreen: () => import('@/static/svg/logo_baemin_green.svg')
  },
  data () {
    return {
      isIOS: false,
      ticking: false,
      latestKnownScrollY: 0
    }
  },
  computed: {
    ...mapGetters({
      writingCategories: 'categories/get_writing_categories'
    }),
    category () {
      return this.writingCategories.filter(item => {
        return item.categoryKoreaName === '배민그린'
      })
    }
  },
  mounted () {
    this.isIOS = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].indexOf(navigator.platform) !== -1

    if (this.isIOS) {
      // requestAnimationFrame(this.backgroundAttachment)
      window.addEventListener('scroll', this.onScroll)
    }
  },
  methods: {
    onScroll () {
      this.latestKnownScrollY = this.$el.getBoundingClientRect().top
      this.requestTick()
    },

    requestTick () {
      if (!this.ticking) {
        requestAnimationFrame(this.backgroundAttachment)
      }
      this.ticking = true
    },

    backgroundAttachment () {
      this.ticking = false
      const currentScrollY = this.latestKnownScrollY
      const el = this.$el.querySelector('.season-image')

      // el.style.backgroundPositionY = `${elOffsetTop * -1}px`
      // el.style.transform = `translateY(${currentScrollY * -1}px)`
      el.style.top = `${currentScrollY * -1}px`
    }
  }
}
</script>
